// @flow

export const ApprovableRevisionEnum = {
  ACTIVE: "active",
  DRAFT: "draft",
};

export const DraftLiveStateEnum = {
  LIVE: "live",
  PENDING: "pending",
  DRAFT: "draft",
};

export const ApprovalStateEnum = {
  DRAFT_ONLY: "DRAFT_ONLY",
  DRAFT_ONLY_PENDING_REVIEW: "DRAFT_ONLY_PENDING_REVIEW",
  ACTIVE_ONLY: "ACTIVE_ONLY",
  ACTIVE_WITH_DRAFT: "ACTIVE_WITH_DRAFT",
  ACTIVE_WITH_DRAFT_PENDING_REVIEW: "ACTIVE_WITH_DRAFT_PENDING_REVIEW",
};

export const ChangesetStateEnum = {
  DRAFT: "DRAFT",
  COMMITTED: "COMMITTED",
  DISCARDED: "DISCARDED",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  DEFERRED: "DEFERRED",
  DECLINED: "DECLINED",
  EFFECTIVE: "EFFECTIVE",
};

export const UnassignReassignShiftPatternTypeEnum = {
  EMPLOYEES: "EMPLOYEES",
  DEPARTMENTS: "DEPARTMENTS",
};

export const UnassignReassignShiftPatternCauseEnum = {
  UNASSIGN: "UNASSIGN",
  REASSIGN: "REASSIGN",
};

export const QuestionTypeEnum = {
  CONFIRMATION: "CONFIRMATION",
  DATE_PICK: "DATE_PICK",
  FREE_TEXT: "FREE_TEXT",
  MULTI_SELECT: "MULTI_SELECT",
  SINGLE_SELECT: "SINGLE_SELECT",
};

export const ReferralsStatusEnum = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const timeAbsencesCanCloseMaxValue = 157680000;

export const EmailDistributionRulesEnum = {
  UPDATES_BATCHED_TOGETHER: "UPDATES_BATCHED_TOGETHER",
  AFTER_EVERY_ABSENCE: "AFTER_EVERY_ABSENCE",
};

export const ABSENCE_REASON_TYPES = {
  ALL: null,
  MEDICAL: 1,
  NON_MEDICAL: 2,
};

export const ABSENCE_REASON_STATE = {
  ALL: null,
  ACTIVE: true,
  INACTIVE: false,
};

export const FULL_NOTIFICATION_CONTACTS = "FULL_NOTIFICATION_CONTACTS";
